// Version information for cache busting and debugging
export const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION || 'dev';
export const BUILD_TIME = process.env.NEXT_PUBLIC_BUILD_TIME || new Date().toISOString();

// Helper to get version info
export function getVersionInfo() {
  return {
    version: APP_VERSION,
    buildTime: BUILD_TIME,
    buildId: process.env.NEXT_PUBLIC_BUILD_ID || 'local',
  };
}